// components/Common/ProductFruitsWrapper.jsx
import React from 'react';
import { ProductFruits } from 'react-product-fruits';
// IMPORT YOUR CUSTOM HOOK FOR GLOBAL STATE HERE
// It is likely one of these based on your imports:
import { useContext } from 'react';
import { GlobalContext } from 'providers/GlobalProvider';

const ProductFruitsWrapper = () => {
  // 1. Get the user from your Global Provider
  // You'll need to check your GlobalProvider file to see exactly how to access 'user'
  const { cur_user } = useContext(GlobalContext);
  const basics = cur_user?.basics;

  // 2. Don't run Product Fruits if the user isn't logged in yet
  if (!cur_user || !basics) {
    return null;
  }

  const resolvedUsername = (
    basics.username ||
    basics.email ||
    basics.id ||
    ''
  ).trim();

  // Product Fruits requires username to be present.
  if (!resolvedUsername) {
    return null;
  }

  // 3. Define the User Info object
  // Product Fruits needs a unique 'username' (usually your DB ID) to track users correctly
  const userInfo = {
    username: resolvedUsername, // MUST be unique. Use ID if possible.
    email: basics.email,
    firstname: basics.firstName, // optional
    lastname: basics.lastName, // optional
    role: 'app user', // optional (useful for segmentation)
  };

  return (
    <ProductFruits
      workspaceCode='SLo7aL7ZJgz5xTtx'
      language='en' // Change this to dynamic language if needed
      user={userInfo}
    />
  );
};

export default ProductFruitsWrapper;
